import React from 'react';
import './Help.scss';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';

const Help = () => {
  return (
    <>
      <Breadcrumbs path={`Help`} />
      <div className="help-section">
        <div className="wrapper">
          <div className="column column1">
            <h2>HELP</h2>
            <div className="email-container">
              <p>
                <a href="/faq">
                  <span className="help-links">&gt; FAQ</span>
                </a>
              </p>
              <p>
                <a href="/shipping-returns">
                  <span className="help-links">&gt; SHIPPING &amp; RETURNS</span>
                </a>
              </p>
              <p>
                <a href="/cgs">
                  <span className="help-links">&gt; TERMS &amp; CONDITIONS</span>
                </a>
              </p>
              <p>
                <a href="/contactus">
                  <span className="help-links">&gt; CONTACT US</span>
                </a>
              </p>
            </div>
          </div>
          <div className="column column2">
            <h2>Customer service hotline</h2>
            <div className="email-container">
              <a
                className="contact-icon contact-email-icon"
                href="mailto: contact@visionhub.com"
                target="_blank"
              >
                contact@visionhub.com
              </a>
            </div>
            <div className="email-container">
              <span className="contact-icon contact-tel-icon">1-888-8-1VISION</span>
              <p>(International rates will apply for call outside US)</p>
            </div>
            <h2>Customer service hours</h2>
            <div className="email-container">Monday to Friday: 9:00 to 18:00 CET</div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Help;
